<div>
	<kendo-combobox #visitCombobox
					[ngClass]="{ 'small-input': layout.elementSize === elementSize.Small, 'error': control?.invalid }"
					[popupSettings]="{width: 'auto'}"
					[data]="filteredPatientVisits"
					[filterable]="true"
					[valuePrimitive]="false"
					[textField]="'visitDescription'"
					[valueField]="'visitNumber'"
					[value]="selectedVisit"
					[clearButton]="false"
					(filterChange)="onVisitFilterChange($event)"
					(selectionChange)="onVisitSelectionChange($event)"
					(click)="onClick($event)"
					[listHeight]="360">
		<ng-template kendoComboBoxItemTemplate let-dataItem>
			<cp-visit-selection-item [visit]="dataItem"></cp-visit-selection-item>
		</ng-template>
	</kendo-combobox>
</div>

<cp-warning-popup *ngIf="pendingSelectedVisit"  (close)="onVisitChangeCanceled()">
	<div class="popup-text">{{'VisitChangeWarning' | cpMessageTranslate}}</div>
	<cp-popup-buttons-ok-cancel class="popup-buttons" (ok)="onVisitChangeOk()" (cancel)="onVisitChangeCanceled()">
	</cp-popup-buttons-ok-cancel>
</cp-warning-popup>

